import { EducationItem } from '@/types/cv';

export const education: EducationItem[] = [
  {
    institution: 'Estácio',
    course: 'Análise e Desenvolvimento de Sistemas',
    degree: 'Tecnólogo',
    period: '2025 - 2027',
    description: [
      'education.description.estacio.0'
    ],
    subjects: []
  },
  {
    institution: 'Rocketseat',
    course: 'Full Stack Developer',
    degree: 'Certificação Técnica',
    period: '2024 - 2026',
    description: [
      'education.description.rocketseat.0'
    ],
    subjects: []
  }
];
